import { Tooltip, withStyles } from '@material-ui/core';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: 'white',
        fontFamily: 'Inter, Roboto, Arial',
        color: 'black',
        fontSize: 16,
        maxWidth: 350
    }
}))(Tooltip);

export default LightTooltip;
